import type { GameState, IndicatorKey } from '../../types/simulation.js';

export interface DashboardSnapshot {
  urgentCount: number;
  unreadCount: number;
  pendingDecisions: number;
  upcomingEvents: GameState['events'];
  headlineIndicators: GameState['indicators'][IndicatorKey][];
  recentJournal: GameState['journal'];
}

export const getDashboardSnapshot = (state: GameState): DashboardSnapshot => {
  const headlineKeys: IndicatorKey[] = ['approval', 'inflation', 'unemployment', 'marketConfidence', 'globalTension'];
  return {
    urgentCount: state.notifications.filter((item) => !item.read && (item.severity === 'urgent' || item.severity === 'critical')).length,
    unreadCount: state.notifications.filter((item) => !item.read).length,
    pendingDecisions: state.decisions.filter((item) => item.status === 'pending').length,
    upcomingEvents: state.events.filter((event) => !event.processed).sort((a, b) => Date.parse(a.scheduledAt) - Date.parse(b.scheduledAt)).slice(0, 6),
    headlineIndicators: headlineKeys.map((key) => state.indicators[key]),
    recentJournal: state.journal.slice(-8).reverse()
  };
};
